export const state = () => ({
    availableInLanguages: ['en', 'nl', 'fr', 'pl', 'de'],
});

export const getters = {
    getLanguagesWithArticles(state) {
        return state.availableInLanguages;
    },
};
